import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FilterList } from 'src/components/filterList';
import { ActionBar, Header } from 'src/components/header';
import { PATHS } from 'src/constants/paths';
import { useFilterAndSorting, useGetAllLayoutType } from 'src/hooks';
import { getLayoutTagName } from 'src/hooks/api/layouts/helpers';
import { useGetAllLayoutTags } from 'src/hooks/api/layouts/useGetAllLayoutTags';
import { IFilter } from 'src/interfaces';
import { lang } from 'src/utils';

import {
  INoScreens,
  IOrientation,
  IOrientationLabel,
  IStatus,
  IStatusLabel,
} from '../listLayoutsPage/ListLayoutsPage.interface';
import { useListLayoutsPage } from './hooks/useListLayoutsPage.hook';
import { LayoutList } from './modules/layoutList/LayoutList';

export const ListLayoutsPage = () => {
  const {
    layoutsDetails,
    onChangeParams,
    isLayoutsLoading,
    errorLayouts,
    getNextLayoutPage,
    totalNumOfLayouts,
    onSortChangeHandle,
    selectedSortOption,
  } = useListLayoutsPage();

  const { data: layoutTypes = [] } = useGetAllLayoutType();
  const { data: layoutTags = [] } = useGetAllLayoutTags(['sort=name']);
  const navigate = useNavigate();

  const filters: IFilter[] = [
    {
      label: 'Status',
      options: Object.values(IStatus).map((value) => ({
        value: value.toLowerCase(),
        label: IStatusLabel[`${value}`],
      })),
    },
    {
      label: 'Layout type',
      options: layoutTypes.map((type) => ({
        value: type.id,
        label: type.name,
      })),
    },
    {
      label: 'Number of screens',
      options: Object.values(INoScreens).map((value) => ({
        value: value,
        label: value,
      })),
    },
    {
      label: 'Screen orientation',
      options: Object.values(IOrientation).map((value) => ({
        value: value,
        label: IOrientationLabel[`${value}`],
      })),
    },
    {
      labelOverride: 'Advanced settings',
      label: 'Advanced filters',
      options: layoutTags.map((tag) => ({
        value: tag.id,
        label: getLayoutTagName(tag.name),
      })),
    },
  ];

  const { onRemoveKeyword, onReset, onChangeKeyword } =
    useFilterAndSorting(filters);

  return (
    <Grid>
      <Header
        title="Layouts"
        actionBar={
          <ActionBar
            title="Layout"
            numResults={totalNumOfLayouts}
            maxResults={layoutsDetails?.pages[0]?.totalCount}
            onHandleClick={() => {
              navigate({
                pathname: PATHS.ASSEMBLY_LAYOUTS_ADD,
              });
            }}
          />
        }
        breadcrumbItems={[
          {
            label: lang.assemblies,
            link: PATHS.ASSEMBLIES,
          },
          {
            label: lang.layouts,
          },
        ]}
      />

      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <FilterList
            filters={filters}
            onChangeFilter={onChangeParams}
            onRemoveKeyword={onRemoveKeyword}
            onChangeKeyword={onChangeKeyword}
            onReset={onReset}
            showReset
          />
        </Grid>

        <Grid item xs={12} md={9}>
          <LayoutList
            isLayoutsLoading={isLayoutsLoading}
            onSortChangeHandle={onSortChangeHandle}
            selectedSortOption={selectedSortOption}
            layoutsDetails={layoutsDetails}
            errorLayouts={errorLayouts}
            totalNumOfLayouts={totalNumOfLayouts}
            getNextLayoutPage={getNextLayoutPage}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
